exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-container[data-v-64d5e9b7]{display:flex;flex-direction:column;background-color:#fff;width:100%;height:330px}img[data-v-64d5e9b7]{width:100%;height:140px}.card-bottom[data-v-64d5e9b7]{justify-content:center;flex:1 0;padding:30px 0;display:flex;flex-direction:column;align-items:center;text-align:center;box-shadow:0 3px 10px rgba(0,0,0,.2)}.card-bottom>*[data-v-64d5e9b7]{font-size:18px;font-weight:500}.card-bottom>a[data-v-64d5e9b7]{margin-top:20px;background:#000;padding:8px 16px;border-radius:8px;color:#fff;text-transform:uppercase}", ""]);

// exports
